import * as types from '../actions/actionTypes';
import initialState from './initialState';


export default function buttonSpinnerReducer(state = initialState.buttonsWithSpinner, action) {
    let buttonsWithSpinner = state.slice();
    const idx = state.indexOf(action.buttonId);
    const isInList = (idx !== -1);

    switch (action.type) {
        case types.ADD_SPINNER_BUTTON_SUCCESS:
            if(!isInList) {
                buttonsWithSpinner.push(action.buttonId);
            }

            return buttonsWithSpinner;
        case types.REMOVE_SPINNER_BUTTON_SUCCESS:
            if(!isInList) {
                return buttonsWithSpinner;
            }

            let modifiedList = state.slice();
            modifiedList.splice(idx, 1);
            return modifiedList;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./web/src/reducers/buttonSpinnerReducer.js